import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const SearchIcon = ({ className = '', width = 16,  height = 15 , color = 'currentColor' }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height={height}
            viewBox='0 0 16 15'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M12 6.5C12 9.53757 9.53757 12 6.5 12C3.46243 12 1 9.53757 1 6.5C1 3.46243 3.46243 1 6.5 1C9.53757 1 12 3.46243 12 6.5ZM11.0962 11.0962C9.91993 12.2725 8.29493 13 6.5 13C2.91015 13 0 10.0899 0 6.5C0 2.91015 2.91015 0 6.5 0C10.0899 0 13 2.91015 13 6.5C13 7.9341 12.5356 9.25973 11.7489 10.3347L15.7071 14.2929L15 15L11.0962 11.0962Z'
                fill={color}
                fillRule='evenodd'/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default SearchIcon;
